import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";
import "./styles.css";
import { AxiosInstance } from "axios";
import { replaceClass } from "../../Tools/Classtools";

const CenterLoading = css`
    margin: 0 auto;
`;

interface ILoading {
    enable?: boolean;
}

export default function Loading(props: ILoading) {
    const EnableLoding = props.enable ? "on" : "off";

    return (
        <>
            <div
                id="loading-component"
                className={`sweet-loading display-Loading-${EnableLoding}`}
            >
                <PuffLoader
                    color="#FFFFFF"
                    loading={true}
                    css={CenterLoading}
                    size={400}
                />
            </div>
        </>
    );
}

export function LoadingRequest(Api: AxiosInstance) {
    Api.interceptors.request.use(
        function (config) {
            replaceClass(
                "loading-component",
                "display-Loading-off",
                "display-Loading-on"
            );
            return config;
        },
        function (error) {
            replaceClass(
                "loading-component",
                "display-Loading-on",
                "display-Loading-off"
            );
            return Promise.reject(error);
        }
    );
}

// Add a response interceptor
export function LoadingResponse(Api: AxiosInstance) {
    Api.interceptors.response.use(
        function (response) {
            replaceClass(
                "loading-component",
                "display-Loading-on",
                "display-Loading-off"
            );
            return response;
        },
        function (error) {
            replaceClass(
                "loading-component",
                "display-Loading-on",
                "display-Loading-off"
            );
            return Promise.reject(error);
        }
    );
}
